import { AWS_CLOUDFROND_BASE_URL } from "../config-global";

export const getSellerPageLoaderImage = () => {
    // if we are on a seller page, return the seller page loader
    if (window.location.pathname.startsWith('/seller')) {
        // we want to check if seller page image is set
        const [, , handler] = window.location.pathname.split('/')
        const normalizedHandler = String(handler).toLowerCase().replaceAll(' ', '_');
        const imageUrl = `${AWS_CLOUDFROND_BASE_URL}/${normalizedHandler}_seller_page_logo`;

        return imageUrl
    }
    return null
}

